import { Platform, StyleSheet, type TextStyle, type ViewStyle } from 'react-native';
import { appTheme, type ThemeColors } from '../../../../shared/theme';
import { androidResolveShadow, androidScaleFont } from '../../../../shared/theme/sharedStyles';
import { DASH_STUDIO_RADIUS } from '../../../../shared/theme/studio/dashboardConstants';

/** Soft shadow for nested strip tiles (menu / online / community / shortcuts) so they lift off the outer shell. */
export function dashboardNestedTileShadow(colors: ThemeColors): ViewStyle {
  if (Platform.OS === 'android') {
    return {
      elevation: 2,
      shadowColor: colors.shadowColor ?? '#0F172A',
    };
  }
  return {
    shadowColor: colors.shadowColor ?? '#0F172A',
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.11,
    shadowRadius: 5,
  };
}

/** Outer dashboard card shell — `surface` (nested tiles / image cards use `surfaceElevated`). */
export function dashboardSet1CardShell(colors: ThemeColors): ViewStyle {
  const ios_shadow: ViewStyle = {
    shadowColor: colors.shadowColor ?? '#0F172A',
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.07,
    shadowRadius: 10,
  };
  const android_shadow: ViewStyle = { elevation: 2 };
  return {
    backgroundColor: colors.surface,
    borderRadius: DASH_STUDIO_RADIUS,
    overflow: 'hidden',
    ...androidResolveShadow(Platform.OS === 'android' ? android_shadow : ios_shadow),
  };
}

export function dashboardSet1SectionLabelStyle(colors: ThemeColors): TextStyle {
  return {
    fontSize: androidScaleFont(11),
    fontWeight: '800',
    letterSpacing: 1.1,
    textTransform: 'uppercase',
    color: colors.textLight,
    marginBottom: appTheme.spacing.sm,
    marginStart: appTheme.spacing.xxs,
  };
}

export const dashboardSet1SectionStyles = StyleSheet.create({
  /** Extra breathing room before labeled sections (Your menu, trends, shortcuts). */
  secondarySection: {
    marginTop: appTheme.spacing.sm,
  },
  tertiarySection: {
    marginTop: appTheme.spacing.xs,
  },
});
